<template>
  <canvas ref="myChart" id="myChart" width="250px"></canvas>
</template>

<script>
import * as Colors from './color'
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  watch: {
    data(n, o) {
      if (n) {

        Object.keys(this.data).forEach((key,index) => {
          this.$chrt.data.labels.push(key)

          this.$chrt.data.datasets.forEach((dataset) => {
            dataset.data.push(this.data[key])
          });
        });


        this.$chrt.update()
      }
    }
  },
  mounted() {
    this.$chrt = new Chart(this.$refs.myChart, {
      type: 'bar',
      data: {
        labels: [ ],
        datasets: [{
          label: 'Province',
          data: [ ],
          backgroundColor: Colors.getColorsAsString(0.2) ,
          borderColor:  Colors.getColorsAsString(),
        }]
      }
    })
  }
}
</script>

<style>

</style>
